import qs from 'qs';

export const buildUrlWithParams = ({
  baseUrl,
  params,
}: {
  baseUrl?: string;
  params: Record<string, boolean | number | string>;
}): string => {
  const url = new URL(baseUrl ?? window.location.href);
  const currentParams = qs.parse(url.search, { ignoreQueryPrefix: true });
  url.search = qs.stringify({ ...currentParams, ...params });

  return url.toString();
};
